import React from "react";
import { t } from "i18next";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import OutsideClickHandler from "react-outside-click-handler";
import { isMobile } from "react-device-detect";
import IndiaIcon from "../Pages/IndiaIcon";

const LanguageSelect = () => {
  const setLanguageModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setLanguageModal;
  });
  const changeLanguage = useContextSelector(AuthContext, (ctx) => {
    return ctx.changeLanguage;
  });
  const lang = useContextSelector(AuthContext, (ctx) => {
    return ctx.lang;
  });
  return (
    <div
      role="document"
      tabIndex={0}
      data-v-c5353408
      className="v-dialog__content v-dialog__content--active"
      style={{ "z-index": "202" }}
    >
      <div
        className="v-dialog v-dialog--active v-dialog--persistent"
        style={{
          "-webkit-transform-origin": "center center",
          "-ms-transform-origin": "center center",
          "transform-origin": "center center",
          "max-width": "450px",
        }}
      >
        <OutsideClickHandler onOutsideClick={() => setLanguageModal(false)}>
          <div
            data-v-c5353408
            className="dialog-card v-card v-sheet theme--light"
          >
            <div
              data-v-c5353408
              className="row no-gutters justify-space-between dialog-header pt-3 px-3"
            >
              <div data-v-c5353408 className="col col-11">
                <label
                  data-v-c5353408
                  className="dialog-title pt-3 ma-0 text-capitalize d-block full-width"
                >
                  {t("CurrencyLanguage")}
                </label>
                {/**/}
              </div>
              <div
                onClick={() => setLanguageModal(false)}
                data-v-c5353408
                className="col col-1"
              >
                <button
                  data-v-c5353408
                  type="button"
                  className="v-icon notranslate v-icon--link mdi mdi-close theme--light dialog-close-icon login"
                />
              </div>
              {/**/}
            </div>
            <div data-v-c5353408 className="row no-gutters px-3 py-3">
              <div data-v-c5353408 className="col col-12">
                <hr
                  data-v-c5353408
                  role="separator"
                  aria-orientation="horizontal"
                  className="dialog-divider v-divider theme--light"
                />
              </div>
            </div>
            <div
              data-v-c5353408
              className="row d-block dialog-row no-gutters pa-3 pt-0"
            >
              <div className="row no-gutters">
                <div className="col col-12 language_panel px-3">
                  <div className="row no-gutters align-center justify-space-between">
                    <div className="col col-2">
                      <div
                        className="v-avatar language-button"
                        style={{
                          height: "35px",
                          "min-width": "35px",
                          width: "35px",
                        }}
                      > <img src="/assets/images/BDT.svg" />
                       
                          
                      </div>
                    </div>
                    <div className="text-center col col-2">
                   
                      <label>   ৳ BDT</label>
                    </div>
                    <div className="col col-8">
                      <div className="full-width v-item-group v-btn-toggle">
                        <div className="row no-gutters">
                          <div
                            onClick={(e) => changeLanguage("en-BD")}
                            className="text-right col col-6 px-1"
                          >
                            <button
                              type="button"
                              value="BDTen"
                              style={isMobile ? { color: "white" } : {}}
                              className={`full-width font-weight-bold v-btn theme--light v-size--default ${
                                lang == "en-BD"
                                  ? "v-item--active v-btn--active v-btn--outlined"
                                  : "v-btn--outlined"
                              }`}
                            >
                              <span className="v-btn__content">English</span>
                            </button>
                          </div>
                          <div
                            onClick={(e) => changeLanguage("bn-BD")}
                            className="text-right col col-6 px-1"
                          >
                            <button
                              type="button"
                              value="BDTbd"
                              style={isMobile ? { color: "white" } : {}}
                              className={`full-width font-weight-bold v-btn theme--light v-size--default ${
                                lang == "bn-BD"
                                  ? "v-item--active v-btn--active v-btn--outlined"
                                  : "v-btn--outlined"
                              }`}
                            >
                              <span className="v-btn__content">Bengali</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="my-2 col col-12">{/**/}</div>
                  </div>
                </div>
                <div className="col col-12 language_panel px-3">
                  <div className="row no-gutters align-center justify-space-between">
                    <div className="col col-2">
                      <div
                        className="v-avatar language-button"
                        style={{
                          height: "35px",
                          "min-width": "35px",
                          width: "35px",
                        }}
                      ><img src="/assets/images/INR.svg" />
                       
                          
                      </div>
                    </div>
                    <div className="text-center col col-2">
                   
                      <label>₹ INR</label>
                    </div>
                    <div className="col col-8">
                      <div className="full-width v-item-group v-btn-toggle">
                        <div className="row no-gutters">
                          <div
                            onClick={(e) => changeLanguage("en-IN")}
                            className="text-right col col-6 px-1"
                          >
                            <button
                              type="button"
                              value="BDTen"
                              style={isMobile ? { color: "white" } : {}}
                              className={`full-width font-weight-bold v-btn theme--light v-size--default ${
                                lang == "en-IN"
                                  ? "v-item--active v-btn--active v-btn--outlined"
                                  : "v-btn--outlined"
                              }`}
                            >
                              <span className="v-btn__content">English</span>
                            </button>
                          </div>
                          <div
                            onClick={(e) => changeLanguage("hi-IN")}
                            className="text-right col col-6 px-1"
                          >
                            <button
                              type="button"
                              value="BDTbd"
                              style={isMobile ? { color: "white" } : {}}
                              className={`full-width font-weight-bold v-btn theme--light v-size--default ${
                                lang == "hi-IN"
                                  ? "v-item--active v-btn--active v-btn--outlined"
                                  : "v-btn--outlined"
                              }`}
                            >
                              <span className="v-btn__content">Hindi</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="my-2 col col-12">{/**/}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default LanguageSelect;
